module.exports = __webpack_public_path__ + "img/conscious.bd2c6653.svg";